import { ErrorBoundary } from '@echoteam/signoz-react';

const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <div className="custom-error">
    <h2>Terjadi Kesalahan!</h2>
    <p>{error.message}</p>
    <button onClick={resetErrorBoundary}>Coba Lagi</button>
  </div>
);

export const ErrorBoundaryProvider = ({ children }) => (
  <ErrorBoundary
    fallback={ErrorFallback}
    onError={(error) => {
      console.log('=====================');
      console.error('[ErrorBoundary]', error);
      console.log('=====================');
    }}
    onReset={() => console.log('Error boundary reset')}
    fallbackClassName="my-error-boundary"
  >
    {children}
  </ErrorBoundary>
);
